import { InputAdornment, Stack, Typography } from '@mui/material';
import { NetworkIcon } from 'modules/common/components/NetworkIcon';

import { ReactNode } from 'react';

interface IMenuItemContent {
  text: ReactNode;
  chainId: number;
  hasIcon: boolean;
}

export function MenuItemContent({
  text,
  chainId,
  hasIcon,
}: IMenuItemContent): JSX.Element {
  return (
    <InputAdornment position="start">
      <Stack direction="row" display="start" alignItems="center">
        {hasIcon && (
          <NetworkIcon chainId={chainId} sx={{ fontSize: 28, mr: 1.25 }} />
        )}
        <Typography noWrap>{text}</Typography>
      </Stack>
    </InputAdornment>
  );
}
